import { mask } from 'vue-the-mask'

import GenericViewMixin from './GenericViewMixin'
import gateways from '../collections/gateways'

export default {
  directives: {
    mask
  },
  mixins: [
    GenericViewMixin
  ],
  props: {
    testMode: {
      type: Boolean,
      required: true
    },
    gateway: {
      type: Object,
      required: false,
      default: () => ({})
    }
  },
  data: () => ({
    gateways: gateways,
    gatewayError: '',
    loaderPay: false
  }),
  methods: {
    createSource (gateway, client = null) {
      return new Promise((resolve, reject) => {
        const payload = {
          gateway: gateway,
          customer: this.customer.id
        }
        this.$store.dispatch('payments/CREATE', {
          resource: 'sources',
          payload: payload,
          headers: {
            headers: {
              'x-simple-workspace': 'acc_JRmsoKHEuwFY'
            }
          }
        })
        .then(() => {
          resolve()
        })
        .catch((error) => {
          reject(error)
        })
      })
    },
    async payExternalGateway (gateway) {
      try {
        this.loaderPay = true
        await this.createSource(gateway)
        await this.authorizePayment()
        window.location.replace(this.paymentsDetail.links.process_url)
      } catch (error) {
        this.gatewayError = error
      } finally {
        this.loaderPay = false
      }
    }
  }
}